module.exports = __webpack_public_path__ + "img/screen_ico_2.52f07dcc.svg";